var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.saving,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "70%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _vm.loading
              ? _c("v-progress-linear", {
                  attrs: { indeterminate: "", color: "yellow darken-2" },
                })
              : _vm._e(),
            _c(
              "v-tabs",
              {
                staticClass: "ma-0",
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c("v-tab", { key: "main" }, [_vm._v("Textos")]),
                _c("v-tab", { key: "show" }, [_vm._v("Exibição")]),
              ],
              1
            ),
            _c(
              "v-tabs-items",
              {
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              [
                _c(
                  "v-tab-item",
                  { key: "main" },
                  [
                    _vm.model
                      ? _c(
                          "v-container",
                          [
                            _vm.acesso.instituicao.id == 1
                              ? _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "12" } },
                                      [
                                        _c(
                                          "v-alert",
                                          {
                                            attrs: {
                                              dense: "",
                                              border: "left",
                                              type: "warning",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " As alterações realizadas serão consideradas "
                                            ),
                                            _c("strong", [_vm._v("PADRÃO")]),
                                            _vm._v(" para as "),
                                            _c("strong", [
                                              _vm._v("DEMAIS INSTITUIÇÕES"),
                                            ]),
                                            _vm._v(". "),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "12" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        autofocus: "",
                                        error: !!_vm.errors.title,
                                        "error-messages": _vm.errors.title,
                                        label: "Título",
                                        clearable: "",
                                        "persistent-placeholder": "",
                                        placeholder: _vm.model.default.title,
                                      },
                                      model: {
                                        value: _vm.model.title,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.model, "title", $$v)
                                        },
                                        expression: "model.title",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "12" } },
                                  [
                                    _c("v-textarea", {
                                      attrs: {
                                        "error-messages": _vm.errors.header,
                                        label: "Cabeçalho",
                                        outlined: "",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.model.header,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.model, "header", $$v)
                                        },
                                        expression: "model.header",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        error: !!_vm.errors.caption_availablity,
                                        "error-messages":
                                          _vm.errors.caption_availablity,
                                        clearable: "",
                                        label:
                                          "Cabeçalho do quadro Disponibilidade",
                                        "persistent-placeholder": "",
                                        placeholder:
                                          _vm.model.default.caption_availablity,
                                      },
                                      model: {
                                        value: _vm.model.caption_availablity,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "caption_availablity",
                                            $$v
                                          )
                                        },
                                        expression: "model.caption_availablity",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        error:
                                          !!_vm.errors.caption_attributions,
                                        "error-messages":
                                          _vm.errors.caption_attributions,
                                        clearable: "",
                                        label:
                                          "Cabeçalho do quadro Atribuições",
                                        "persistent-placeholder": "",
                                        placeholder:
                                          _vm.model.default
                                            .caption_attributions,
                                      },
                                      model: {
                                        value: _vm.model.caption_attributions,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "caption_attributions",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.caption_attributions",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "4" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        error:
                                          !!_vm.errors
                                            .caption_class_time_tables,
                                        "error-messages":
                                          _vm.errors.caption_class_time_tables,
                                        clearable: "",
                                        label:
                                          "Cabeçalho do quadro Horário das Aulas",
                                        "persistent-placeholder": "",
                                        placeholder:
                                          _vm.model.default
                                            .caption_class_time_tables,
                                      },
                                      model: {
                                        value:
                                          _vm.model.caption_class_time_tables,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "caption_class_time_tables",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.caption_class_time_tables",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "4" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        error: !!_vm.errors.caption_activities,
                                        "error-messages":
                                          _vm.errors.caption_activities,
                                        clearable: "",
                                        label:
                                          "Cabeçalho Quadro Atividades Docentes",
                                        "persistent-placeholder": "",
                                        placeholder:
                                          _vm.model.default.caption_activities,
                                      },
                                      model: {
                                        value: _vm.model.caption_activities,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "caption_activities",
                                            $$v
                                          )
                                        },
                                        expression: "model.caption_activities",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "4" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        error:
                                          !!_vm.errors.caption_activities_admin,
                                        "error-messages":
                                          _vm.errors.caption_activities_admin,
                                        clearable: "",
                                        label:
                                          "Cabeçalho Quadro Atividades Administrativas",
                                        "persistent-placeholder": "",
                                        placeholder:
                                          _vm.model.default
                                            .caption_activities_admin,
                                      },
                                      model: {
                                        value:
                                          _vm.model.caption_activities_admin,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "caption_activities_admin",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.caption_activities_admin",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "3" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        error:
                                          !!_vm.errors
                                            .caption_activity_time_tables,
                                        "error-messages":
                                          _vm.errors
                                            .caption_activity_time_tables,
                                        clearable: "",
                                        label:
                                          "Cabeçalho do quadro Horário das Atividades",
                                        "persistent-placeholder": "",
                                        placeholder:
                                          _vm.model.default
                                            .caption_activity_time_tables,
                                      },
                                      model: {
                                        value:
                                          _vm.model
                                            .caption_activity_time_tables,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "caption_activity_time_tables",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.caption_activity_time_tables",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "3" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        error: !!_vm.errors.caption_summary,
                                        "error-messages":
                                          _vm.errors.caption_summary,
                                        clearable: "",
                                        label: "Cabeçalho do Quadro Resumo",
                                        "persistent-placeholder": "",
                                        placeholder:
                                          _vm.model.default.caption_summary,
                                      },
                                      model: {
                                        value: _vm.model.caption_summary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "caption_summary",
                                            $$v
                                          )
                                        },
                                        expression: "model.caption_summary",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "3" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        error: !!_vm.errors.caption_joins,
                                        "error-messages":
                                          _vm.errors.caption_joins,
                                        clearable: "",
                                        label: "Cabeçalho do Quadro de Junção",
                                        "persistent-placeholder": "",
                                        placeholder:
                                          _vm.model.default.caption_joins,
                                      },
                                      model: {
                                        value: _vm.model.caption_joins,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "caption_joins",
                                            $$v
                                          )
                                        },
                                        expression: "model.caption_joins",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "3" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        error:
                                          !!_vm.errors
                                            .text_additional_signature,
                                        "error-messages":
                                          _vm.errors.text_additional_signature,
                                        clearable: "",
                                        label:
                                          "Responsável Assinatura Adicional",
                                        "persistent-placeholder": "",
                                        placeholder:
                                          _vm.model.default
                                            .text_additional_signature,
                                      },
                                      model: {
                                        value:
                                          _vm.model.text_additional_signature,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "text_additional_signature",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.text_additional_signature",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "10" } },
                                  [
                                    _c("v-textarea", {
                                      attrs: {
                                        "error-messages":
                                          _vm.errors.text_work_load_reduction,
                                        label: "Texto Redução de Carga Horária",
                                        outlined: "",
                                        clearable: "",
                                        id: "editor",
                                        placeholder:
                                          "Utilize as tags para configuração do texto",
                                      },
                                      on: {
                                        "selection-change": function ($event) {
                                          _vm.range = $event
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.model.text_work_load_reduction,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "text_work_load_reduction",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.text_work_load_reduction",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "2" } },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.tags,
                                        "return-object": "",
                                        "item-text": "name",
                                        "hide-details": "",
                                        label: "Tags",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.setField($event)
                                        },
                                      },
                                      model: {
                                        value: _vm.selectedTag,
                                        callback: function ($$v) {
                                          _vm.selectedTag = $$v
                                        },
                                        expression: "selectedTag",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", sm: "12" } },
                                  [
                                    _c("v-textarea", {
                                      attrs: {
                                        "error-messages": _vm.errors.footer,
                                        label: "Rodapé",
                                        outlined: "",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.model.footer,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.model, "footer", $$v)
                                        },
                                        expression: "model.footer",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "v-tab-item",
                  { key: "show" },
                  [
                    _vm.model
                      ? _c(
                          "v-container",
                          { staticClass: "px-6 py-4" },
                          _vm._l(_vm.showSections, function (section, index) {
                            return _c(
                              "section",
                              {
                                key: section.title,
                                class: { "mt-6": index > 0 },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-center" },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: { small: "", color: "primary" },
                                      },
                                      [_vm._v(_vm._s(section.icon))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-subtitle-2 font-weight-bold text-uppercase primary--text",
                                      },
                                      [_vm._v(_vm._s(section.title))]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-caption grey--text text--darken-1 mt-1",
                                  },
                                  [_vm._v(_vm._s(section.description))]
                                ),
                                _c("v-divider", { staticClass: "mt-2 mb-3" }),
                                _c(
                                  "v-row",
                                  { attrs: { dense: "" } },
                                  _vm._l(section.items, function (item) {
                                    return _c(
                                      "v-col",
                                      {
                                        key: item.key,
                                        staticClass: "py-0",
                                        attrs: { cols: "12", sm: "6", md: "4" },
                                      },
                                      [
                                        _c("s-switch", {
                                          attrs: {
                                            dense: "",
                                            inset: "",
                                            "text-helper": item.help,
                                            label: item.label,
                                          },
                                          model: {
                                            value: _vm.model[item.key],
                                            callback: function ($$v) {
                                              _vm.$set(_vm.model, item.key, $$v)
                                            },
                                            expression: "model[item.key]",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }